import i18n from '@/plugins/i18n';

export default () => {
  return {
    fields: [
      {
        key: 'actions',
        label: i18n.t('Actions')
      },
      {
        key: 'domain',
        label: i18n.t('Domain')
      },
      {
        key: 'action_name',
        label: i18n.t('Affiliate')
      },
      {
        key: 'action_token',
        label: i18n.t('Actions (Links)') + ' - ' + i18n.t('Token')
      },
      {
        key: 'campaign_name',
        label: i18n.t('Campaign')
      },
      {
        key: 'url',
        label: 'URL'
      }
    ]
  };
};
